import React, {
  useState,
  useEffect
} from "react";
import "../styles/Conversions.css";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";

/* ─── Icons ─── */
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);
const ChevronLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: false,path: "/dashboard" },
  { label: "Conversions", icon: <RepeatIcon />, active: true,path: "/conversions" },
  { label: "Payments", icon: <CreditCardIcon />, active: false,path: "/payments" },
  { label: "Settings", icon: <SettingsIcon />, active: false,path: "/settings" },
  { label: "Help", icon: <HelpIcon />, active: false,path: "/help" },
];

/* ─── Sidebar ─── */
function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = JSON.parse(
    localStorage.getItem("currentUser") || "null"
    );
    const handleLogout = () => {
          localStorage.removeItem("currentUser");
          localStorage.removeItem("selectedPlan");
          navigate("/");
        };

  return (
    <aside className="cv-sidebar">
      <div className="cv-sidebar-upper">
        <div className="cv-profile">
          <div className="cv-avatar">
                    {currentUser.full_name
                                  ? currentUser.full_name
                                      .split(" ")
                                      .map((n) => n[0])
                                      .join("")
                                      .substring(0, 2)
                                      .toUpperCase()
                                  : "U"}
                    </div>
          <div className="cv-profile-info">
            <span className="cv-profile-name">{currentUser?.full_name || "Guest"}</span>
            <span className="cv-profile-role">{currentUser?.email || ""}</span>
          </div>
        </div>
        <nav className="cv-nav">
          {NAV_ITEMS.map((item) => (
                        <Link
                          key={item.label}
                          to={item.path}
                          className={`db-nav-item ${
                            location.pathname === item.path
                              ? "db-nav-item--active"
                              : ""
                          }`}
                        >
                          <span className="db-nav-icon">
                            {item.icon}
                          </span>
                          {item.label}
                        </Link>
                      ))}
                  {/* ─── Logout separator + button ─── */}
                                        <div className="db-nav-separator" />
                                        <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                          <span className="db-nav-icon">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                              <polyline points="16 17 21 12 16 7" />
                                              <line x1="21" y1="12" x2="9" y2="12" />
                                            </svg>
                                          </span>
                                          Log Out
                                        </button>
        </nav>
      </div>
    </aside>
  );
}

/* ─── Status Badge ─── */
function StatusBadge({ status }) {
  const config = {
    COMPLETED: {
      className: "cv-status--completed",
      dot: "#10B981"
    },
    PROCESSING: {
      className: "cv-status--processing",
      dot: "#F59E0B"
    },
    FAILED: {
      className: "cv-status--failed",
      dot: "#EF4444"
    }
  };
const { className, dot } =
  config[status] || config.COMPLETED;
  return (
    <span className={`cv-status-badge ${className}`}>
      <span className="cv-status-dot" style={{ background: dot }} />
      {status}
    </span>
  );
}

/* ─── Action Button ─── */
function ActionButton({ downloadUrl }) {
  return (
    <a
      href={downloadUrl}
      target="_blank"
      rel="noopener noreferrer"
      >
      Download
    </a>
  );
}

/* ─── Main Content ─── */
function MainContent() {
    const API_URL = process.env.REACT_APP_API_URL;
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [conversions, setConversions] = useState([]);
  const [loading, setLoading] = useState(true);

const filteredConversions =
  conversions.filter((c) => {

    const matchFilter =
      activeFilter === "all"
      ||
      c.status.toLowerCase()
      === activeFilter;

    const matchSearch =
      c.fileName
        ?.toLowerCase()
        .includes(
          searchQuery.toLowerCase()
        );

    return (
      matchFilter &&
      matchSearch
    );
  });

    const FILTER_TABS = [
      {
        label: "All",
        count: conversions.length,
        key: "all"
      },
      {
        label: "Completed",
        count: conversions.filter(
          x =>
          x.status === "COMPLETED"
        ).length,
        key: "completed"
      },
      {
        label: "Processing",
        count: conversions.filter(
          x =>
          x.status === "PROCESSING"
        ).length,
        key: "processing"
      },
      {
        label: "Failed",
        count: conversions.filter(
          x =>
          x.status === "FAILED"
        ).length,
        key: "failed"
      }
    ];

  useEffect(() => {

    const currentUser =
      JSON.parse(
        localStorage.getItem(
          "currentUser"
        ) || "null"
      );

    if (!currentUser) return;

    const fetchConversions =
      async () => {

        try {

          const response =
            await fetch(
              `${API_URL}/history/${currentUser.user_id}`
            );

          const data =
            await response.json();

          setConversions(data || []);

        } catch (err) {

          console.error(err);

        } finally {

          setLoading(false);

        }
      };

    fetchConversions();

  }, [API_URL]);

    if (loading) {

            return (
              <div
                className="cv-loading"
              >
                Loading conversions...
              </div>
            );

          }

  return (
    <main className="cv-main">
      {/* Page Header */}
      <div className="cv-page-header">
        <div>
          <h1 className="cv-page-title">My Conversions</h1>
          <p className="cv-page-sub">View and manage all your file conversion jobs</p>
        </div>
        <div className="cv-header-actions">
          <div className="cv-search-box">
            <SearchIcon />
            <input
              type="text"
              placeholder="Search file jobs..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="cv-search-input"
            />
          </div>
          <Link
            to="/newconversions"
            className="cv-new-btn"
          >
            <PlusIcon />
            New Conversion
          </Link>
        </div>
      </div>

      {/* Filter Tabs */}
      <div className="cv-filter-row">
        {FILTER_TABS.map((tab) => (
          <button
            key={tab.key}
            className={`cv-filter-pill ${activeFilter === tab.key ? "cv-filter-pill--active" : ""}`}
            onClick={() => setActiveFilter(tab.key)}
          >
            {tab.label}
            <span className="cv-filter-count">{tab.count}</span>
          </button>
        ))}
      </div>

      {/* Table Card */}
      <div className="cv-table-card">
        <div className="cv-table-head">
          <span>FILE NAME</span>
          <span>FORMAT</span>
          <span>SIZE</span>
          <span>STATUS</span>
          <span>DATE</span>
          <span>ACTIONS</span>
        </div>
        {filteredConversions.map((row, i) => (
          <div key={i} className="cv-table-row">
            <div className="cv-file-info">
              <span className="cv-file-name">{row.fileName}</span>
              <span className="cv-file-sub">{row.outputFile}</span>
            </div>
            <div className="cv-format-col">
              <span className="cv-format-tag">{row.fromFormat}</span>
              <ArrowIcon />
              <span className="cv-format-tag cv-format-tag--target">{row.toFormat}</span>
            </div>
            <span className="cv-size-col">{`${(
                                             row.fileSize /
                                             (1024 * 1024)
                                           ).toFixed(2)} MB`}</span>
            <span className="cv-status-col"><StatusBadge status={row.status} /></span>
            <span className="cv-date-col">{row.convertedAt}</span>
            <span className="cv-action-col"><ActionButton downloadUrl={row.downloadUrl} /></span>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="cv-pagination">
        <span className="cv-page-info">
          Showing <strong>{filteredConversions.length}</strong> of <strong>{conversions.length}</strong> results
        </span>
        <div className="cv-page-controls">
          <button className="cv-page-btn" disabled><ChevronLeft /> Previous</button>
          <button className="cv-page-num cv-page-num--active">1</button>
          <button className="cv-page-num">2</button>
          <button className="cv-page-num">3</button>
          <span className="cv-page-ellipsis">...</span>
          <button className="cv-page-num">1,606</button>
          <button className="cv-page-btn">Next <ChevronRight /></button>
        </div>
      </div>
    </main>
  );
}

/* ─── Conversions Page ─── */
export default function ConvertProConversions() {

  return (
    <div className="cv-layout">
      <Sidebar />
      <MainContent />
    </div>
  );
}
